import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { getSupplier } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useTranslation } from 'next-i18next';
import { Sticky } from '@bridebook/web/app-shared/components/sticky';
import { Flex, Text } from '@bridebook/aura';
import { BookAViewingButton } from '../cta-buttons/book-a-viewing/book-a-viewing-button';
import { useIsShowroundsLoggedOutUsers_LIVE28500_Enabled } from '@bridebook/web/app-basic/lib/ab-tests/tests/LIVE-28500_ShowroundsLoggedOutUsers';
import { ToggleEnquiryFormButtonAura } from '@bridebook/web/app-basic/components/supplier/toggle-enquiry-form-button-aura';

const StickyBrochureRequestCard = () => {
  const { t } = useTranslation('supplier');

  const supplier = useSelector(getSupplier);
  const isShowroundsLoggedOutUsersEnabled = useIsShowroundsLoggedOutUsers_LIVE28500_Enabled();

  if (!supplier) return null;

  return (
    <Sticky>
      <div className="relative w-full">
        <Flex className="min-w-[296px] flex-col gap-4 rounded-lg bg-indigo-crush-04 p-4">
          <Text as="h5" className="text-center text-indigo-crush" variant="typo-base-semibold">
            {t('stickyBrochure.title')}
          </Text>
          <ToggleEnquiryFormButtonAura contactMethod="supplierProfile_stickyBottomBar" />
          {isShowroundsLoggedOutUsersEnabled && <BookAViewingButton />}
        </Flex>
      </div>
    </Sticky>
  );
};

export default StickyBrochureRequestCard;
